module.exports = __webpack_public_path__ + "media/images/athletes/2754-776406b15e1c4c6f0414bc722b919de9.png";